import { render, staticRenderFns } from "./drawerProjectsConfigTemplate.vue?vue&type=template&id=3810acd6&"
import script from "./drawerProjectsConfigTemplate.vue?vue&type=script&lang=js&"
export * from "./drawerProjectsConfigTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports